import {
    COST_ELEMENT_FETCHING,
    COST_ELEMENT_FAILED,
    COST_ELEMENT_SUCCESS,
  } from "../actions/types";
  
  const initialState = {
    result: null,
    isFetching: false,
    isError: false,
  };
  
  export default function (state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
      case COST_ELEMENT_FETCHING:
        return { ...state, result: null, isFetching: true, isError: false };
      case COST_ELEMENT_FAILED:
        return { ...state, result: null, isFetching: false, isError: true };
      case COST_ELEMENT_SUCCESS:
        return { ...state, result: payload, isFetching: false, isError: false };
      default:
        return state;
    }
  }
  